import React from "react";
import styled from "styled-components";
import colors from "../config/colors";

import Headline from "../components/Headline";
import Strong from "../components/Strong";
import ContentSection from "../components/ContentSection";
import DoItems from "../components/DoItems";
import ContactOnline from "../components/ContactOnline";
import ContactMobile from "../components/ContactMobile";
import ContactOffline from "../components/ContactOffline";
import Row from "../components/Row";
import Col from "../components/Col";

import frontendSvg from "../images/do/frontend.svg";
import consultingSvg from "../images/do/consulting.svg";
import mobileSvg from "../images/do/mobile.svg";
import qualitySvg from "../images/do/quality.svg";

// TODO use fragments instead of spans in headlines when gatsby has react 16
export default () => (
  <ContentSection color={colors.yellow} id="contact">
    <Headline>
      <Strong>Kontakt</Strong>
    </Headline>
    <Row>
      <Col>
        <ContactOnline />
      </Col>
      <Col>
        <ContactMobile />
        <ContactOffline />
      </Col>
    </Row>
  </ContentSection>
);



// WEBPACK FOOTER //
// ./src/components/Contact.js